import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  bookingsTab: {
    //
  }
});

export default styles;
